import api from "../api";

const controller = '/NaoPrevistoOrcamentoSolicitacao';

export interface OrcamentoSolicitacaoNaoPrevisto {
    id: string;
    index: number;
    contaContabil?: string;
    agrupador?: string;
    sigla?: string;
    disciplina?: string;
    tipo?: string;
    pacote: string;
    descricaoPacote: string;
    janeiro?: number;
    fevereiro?: number;
    marco?: number;
    abril?: number;
    maio?: number;
    junho?: number;
    julho?: number;
    agosto?: number;
    setembro?: number;
    outubro?: number;
    novembro?: number;
    dezembro?: number;
    janeiroFinanceiro?: number;
    fevereiroFinanceiro?: number;
    marcoFinanceiro?: number;
    abrilFinanceiro?: number;
    maioFinanceiro?: number;
    junhoFinanceiro?: number;
    julhoFinanceiro?: number;
    agostoFinanceiro?: number;
    setembroFinanceiro?: number;
    outubroFinanceiro?: number;
    novembroFinanceiro?: number;
    dezembroFinanceiro?: number;
    total?: number;
    totalFinanceiro?: number;
    solicitacaoNaoPrevistoId: string;
}

export const getOrcamentoSolicitacaoNaoPrevisto = async (id: string) => {
    return await api.get<OrcamentoSolicitacaoNaoPrevisto[]>(`${controller}/listar/${id}`, {}, {}, 'false');
}

export const getOrcamentoSolicitacaoNaoFinanceiroPrevisto = async (id: string) => {
    return await api.get<OrcamentoSolicitacaoNaoPrevisto[]>(`${controller}/listar/financeiro/${id}`, {}, {}, 'false');
}


export const createOrcamentoSolicitacaoNaoPrevisto = async (item: { solicitacaoNaoPrevistoId: string }) => {
    return await api.post(`${controller}`, item);
}

export const updateOrcamentoSolicitacaoNaoPrevisto = async (item: OrcamentoSolicitacaoNaoPrevisto) => {
    return await api.put(`${controller}`, item);
}

export const updateOrcamentoFinanceiroSolicitacaoNaoPrevisto = async (item: { id: string }) => {
    return await api.put(`${controller}/financeiro`, item);
}

export const updateAllOrcamentoFinanceiroSolicitacaoNaoPrevisto = async (item: { solicitacaoNaoPrevistoId: string }) => {
    return await api.put(`${controller}/financeiro/todos`, item);
}

export const deleteOrcamentoSolicitacaoNaoPrevisto = async (id: string) => {
    return await api.delete(`${controller}/${id}`);
}